import { library } from "@fortawesome/fontawesome-svg-core";
import {} from "@fortawesome/free-solid-svg-icons";

import {} from "@fortawesome/pro-solid-svg-icons";

library.add();

export {};
